import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
export default class Button extends Component {
    static propTypes = {
        active: PropTypes.bool.isRequired,
        className: PropTypes.string,
        disable: PropTypes.bool,
        hidden: PropTypes.bool,
        isNew: PropTypes.bool,
        locale: PropTypes.string.isRequired,
        onClickHandler: PropTypes.func,
        style: PropTypes.object,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    }

    static defaultProps = {
        className: '',
        hidden: false,
        onClickHandler: () => {},
        style: {},
    }

    shouldComponentUpdate() {
        if (this.props.hidden) return false
        return true
    }

    render() {
        const { active, className, disable, hidden, onClickHandler, style, text, isNew, locale } = this.props

        const disableIcon = disable && <div className={'disableIcon'} />
        const isNewIcon = isNew && <div className={cx('isNewIcon', locale)} />

        return (
            <div
                className={cx(
                    'button',
                    active && 'active',
                    hidden && 'hidden',
                    disable && 'disable',
                    `button--${className}`
                )}
                onClick={onClickHandler}
                style={style}
            >
                {text}
                {disableIcon}
                {isNewIcon}
            </div>
        )
    }
}
